<template>
  <div
    v-if="show"
    :class="['template-container', containerClass]"
    :style="containerStyle"
    @click="handleOuterClick"
  >
    <template v-if="withTransition">
      <transition name="template-modal" appear>
        <div
          v-if="isShowing"
          :class="['template-content', center ? 'center' : '', contentClass]"
          :style="contentStyle"
        >
          <div @click.stop.prevent class="wrapper">
            <slot></slot>
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <div
        v-if="isShowing"
        :class="['template-content', center ? 'center' : '', contentClass]"
        :style="contentStyle"
      >
        <div @click.stop.prevent class="wrapper">
          <slot></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    center: {
      type: Boolean,
      default: false,
    },
    withTransition: {
      type: Boolean,
      default: true,
    },
    containerClass: String,
    contentClass: String,
    containerStyle: [String, Object],
    contentStyle: [String, Object],
    preventOuterClick: Boolean,
  },
  data() {
    return {
      isShowing: false,
    };
  },
  methods: {
    handleOuterClick(e) {
      if (this.preventOuterClick) {
        return;
      }
      this.isShowing = this.false;
      setTimeout(() => {
        this.$emit("handleClose");
      }, 300);
    },
  },
  watch: {
    show() {
      if (this.show) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "auto";
      }
      this.isShowing = this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
.template-container {
  /* VAR AS IN BOOTSRAP */
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.5rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.5rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 1px;
  /* ==== */
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1100;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.template-content {
  @media (min-width: 576px) {
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }

  &.center {
    display: flex;
    align-items: center;
    height: calc(100% - 1.75rem);
    margin-top: 0;
    margin-bottom: 0;
  }

  width: auto;
  margin: 1.75rem;

  .wrapper {
    width: 100%;
  }
}

.template-modal-enter-active,
.template-modal-leave-active {
  transform: none;
  opacity: 1;
  transition: all 0.3s ease-out;
}

.template-modal-enter-from,
.template-modal-leave-to {
  transform: translate(0, -50px);
  opacity: 0;
  transition: all 0.3s ease-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
